import { $color, UIColor } from '../ui/color';
import { $el } from '../ui/elements';
import { UIView } from '../ui/view';
import { CHChart } from './chart';

export interface CHLegendItem {
    color: UIColor;
    label: string;
    enabled: boolean;
}

export class CHLegendBar extends UIView {
    constructor() {
        super('div', 'ch-legend-bar');
    }

    private _fill(items: CHLegendItem[]) {
        this.ui_empty();

        for(const i of items) {
            const color = $el.DIV('r-color');
            if(i.enabled)
                color.style.backgroundColor = $color.HEX(i.color);
            this.ui_add([color, $el.SPAN('r-label', i.label)]);
            color.addEventListener('click', () => {
                i.enabled = !i.enabled;
                color.style.backgroundColor = i.enabled ? $color.HEX(i.color) : 'transparent';
            });
        }
    }

    set chart(chart: CHChart) {
        this._fill(chart.legend_items);
    }
}